import { toBackendFormat, toFrontendFormat } from '@Ravnur-Inc/http';
import axios from 'axios';
import { stringify } from 'qs';

import { instance as typedStore } from '@/store';

const UNAUTH_CODE = 401;

axios.interceptors.request.use((config) => {
  config.paramsSerializer = { serialize: (params) => stringify(params, { arrayFormat: 'repeat' }) };
  config.params = toBackendFormat(config.params);
  config.data = toBackendFormat(config.data);
  config.withCredentials = true;
  return config;
});

axios.interceptors.response.use(
  (resp) => {
    resp.data = toFrontendFormat(resp.data);
    return resp;
  },
  (error) => {
    if (error.response.status === UNAUTH_CODE && typedStore.user.isAuth) {
      if (!typedStore.isLogouting) {
        location.reload();
      }
    }
    return Promise.reject(toFrontendFormat(error));
  }
);
